<template>
  <v-card :loading="loading">
    <v-toolbar color="primary" flat dark>
      Изменение пост-индекса пост пакета
    </v-toolbar>

    <v-card-text>
      <v-text-field v-model="postCode"
                    label="Пост индекс"
                    :error-messages="postCodeErrorMessages"
      />
    </v-card-text>

    <v-card-actions>
      <v-btn color="default" small text @click="onCloseClicked" :disabled="loading">Закрыть</v-btn>
      <v-spacer/>
      <v-btn color="primary" small text @click="onChangeClicked" :disabled="loading">Сохранить</v-btn>
    </v-card-actions>

    <v-snackbar v-model="isChangeFailed"
                :timeout="5000"
                :top="true"
                color="error"
    >
      Не удалось сохранить новый пост-индекс
    </v-snackbar>
  </v-card>
</template>

<script>
import {required, numeric, minLength, maxLength} from 'vuelidate/lib/validators'
import PostPackageService from '../services/post.package.service'
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP} from "@/store/modules/layout/actions";
import {APP_POST_PACKAGE_POST_CODE_CHANGED} from "@/store/modules/app/actions";

export default {
  name: "ChangePostPackagePostCode",
  props: {
    postPackage: {
      default: null,
      type: Object
    }
  },
  data() {
    return {
      loading: false,
      isChangeFailed: false,

      postCode: null
    }
  },
  computed: {
    postCodeErrorMessages() {
      const errors = []

      if (this.$v.postCode.$dirty) {
        !this.$v.postCode.required && errors.push(`Введите новый индекс`)

        if (this.$v.postCode.required) {
          !this.$v.postCode.numeric && errors.push(`Доступно только цифры`)
          !this.$v.postCode.minLength && errors.push(`Минимум 6 цифр`)
          !this.$v.postCode.maxLength && errors.push(`Максимум 6 цифр`)
        }
      }

      return errors
    }
  },
  validations: {
    postCode: {
      required,
      numeric,
      minLength: minLength(6),
      maxLength: maxLength(6)
    }
  },
  methods: {
    resetValues() {
      this.postCode = this.postPackage.postCode
    },

    clear() {
      this.$v.$reset()
      this.resetValues()
    },

    onCloseClicked() {
      this.clear()
      this.$emit('close')
    },
    onChangeClicked() {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.isChangeFailed = false
        this.loading = true
        this.$store.dispatch(LAYOUT_LOADING_START)

        PostPackageService.changePostCode({postPackage: this.postPackage, postCode: this.postCode})
            .then(() => {
              this.$store.dispatch(APP_POST_PACKAGE_POST_CODE_CHANGED, {
                postPackage: this.postPackage,
                postCode: this.postCode
              })
            })
            .catch(() => {
              this.isChangeFailed = true
            })
            .finally(() => {
              this.loading = false
              this.$store.dispatch(LAYOUT_LOADING_STOP)
            })
      }
    }
  },
  created() {
    this.resetValues()
  }
}
</script>

<style scoped>

</style>